<template>
    <div id="producerDetaliss">
      <ProducerDetails :data="is_admin_dealer" />
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import ProducerDetails from "../producer/ProducerDetails.vue"
  
  
  export default {
    name: "producerDetaliss",
    created() {
      
    },
    data() {
      return {
        is_admin_dealer:1
      };
    },
    components: {
        ProducerDetails
    },
   
    methods: {
     
    },
   
  };
  </script>
  
  <style scoped>
  
  </style>